import { useState } from 'react';
import { Textarea } from './ui/textarea';
import { Button } from './ui/button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';
import ReactMarkdown from 'react-markdown';
import { Eye, Edit3 } from 'lucide-react';

export const MarkdownEditor = ({ value, onChange, placeholder, minHeight = '300px' }) => {
  const [activeTab, setActiveTab] = useState('edit');

  return (
    <div className="border border-sand-200 rounded-xl overflow-hidden">
      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <div className="bg-sand-100 px-4 py-2 border-b border-sand-200">
          <TabsList className="h-9">
            <TabsTrigger value="edit" className="text-sm">
              <Edit3 className="w-4 h-4 mr-2" />
              Éditer
            </TabsTrigger>
            <TabsTrigger value="preview" className="text-sm">
              <Eye className="w-4 h-4 mr-2" />
              Aperçu
            </TabsTrigger>
          </TabsList>
        </div>

        <TabsContent value="edit" className="p-4 m-0">
          <Textarea
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            className="border-0 focus:ring-0 font-mono text-sm resize-none"
            style={{ minHeight }}
          />
        </TabsContent>

        <TabsContent value="preview" className="p-6 m-0" style={{ minHeight }}>
          {value ? (
            <div className="markdown-content prose prose-sage max-w-none">
              <ReactMarkdown>{value}</ReactMarkdown>
            </div>
          ) : (
            <p className="text-sage-700/40 font-sans text-sm italic">Aucun contenu à prévisualiser</p>
          )}
        </TabsContent>
      </Tabs>

      <div className="bg-sand-50 px-4 py-2 border-t border-sand-200">
        <p className="text-xs text-sage-700/60 font-sans">
          <strong>Markdown :</strong> # Titre, ## Sous-titre, **gras**, *italique*, - liste
        </p>
      </div>
    </div>
  );
};

export default MarkdownEditor;